import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constant } from '../common/constant';
import { ResidentAddModel } from '../models/resident.model';
import { Observable } from 'rxjs';

@Injectable()
export class ScrapAgentService {
  

    constructor(private readonly http: HttpClient) {
    }

    getScrapAgentList(accountId, flatId) {
        const url = Constant.REST_URL + Constant.SCRAP_AGENT + Constant.GET_SCRAP_AGENT_LIST +
            '?flatId=' + flatId + '&accountId=' + accountId;
        return this.http.get(url);
    }

    registerScrapAgentDetails(details) {
        const url = Constant.REST_URL + Constant.SCRAP_AGENT + Constant.REGISTER_SCRAP_AGENT_DETAILS;
        return this.http.post(url, details);
    }

    deleteScrapAgentDetails(id) {
        const url = Constant.REST_URL + Constant.SCRAP_AGENT + Constant.DELETE_SCRAP_AGENT_INFO +
            '?id=' + id;
        return this.http.get(url);
    }

      getAllScrapAgentNameList(accountId) {
        const url = Constant.REST_URL + Constant.SCRAP_AGENT + Constant.GET_ALL_SCRAP_AGENT_NAME +'?&accountId=' + accountId;
        return this.http.get(url);
    }
}
